// Shared Leaflet basemap tile source.
//
// The client's corporate network (FortiGate) SSL-intercepts and BLOCKS the usual tile hosts —
// tile.openstreetmap.org, *.basemaps.cartocdn.com, *.google.com/vt — so those maps render as a
// blank grey box with only the marker + zoom controls (the browser gets a block page instead of an
// image → net::ERR_BLOCKED_BY_ORB). Esri's ArcGIS Online tiles (server.arcgisonline.com) ARE reachable
// in that environment and need no API key (verified: OSM/Carto/Google return a block/self-signed
// intercept, Esri returns a real image tile). Note Esri uses {z}/{y}/{x} order, not {z}/{x}/{y}.
export const MAP_TILE_URL =
  'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}';
export const MAP_TILE_ATTRIBUTION = 'Tiles &copy; Esri';
